import React from 'react';
import { Shield, CheckCircle, AlertCircle, Clock, Lock } from 'lucide-react';

const EscrowStatusBadge = ({ status }) => {
  const getStatusConfig = () => {
    switch(status) {
      case 'pending':
        return {
          label: 'Pending Payment',
          color: 'bg-yellow-100 text-yellow-800',
          icon: <Clock className="w-3 h-3" />
        };
      case 'held':
        return {
          label: 'Funds Secured',
          color: 'bg-green-100 text-green-800',
          icon: <Lock className="w-3 h-3" />
        };
      case 'released':
        return {
          label: 'Payment Released',
          color: 'bg-blue-100 text-blue-800',
          icon: <CheckCircle className="w-3 h-3" />
        };
      case 'disputed':
        return {
          label: 'Disputed',
          color: 'bg-orange-100 text-orange-800',
          icon: <AlertCircle className="w-3 h-3" />
        };
      case 'refunded':
        return {
          label: 'Refunded',
          color: 'bg-purple-100 text-purple-800',
          icon: <Shield className="w-3 h-3" />
        };
      default:
        return {
          label: status || 'Unknown',
          color: 'bg-gray-100 text-gray-800',
          icon: <Shield className="w-3 h-3" />
        };
    }
  };

  const config = getStatusConfig();

  return (
    <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium ${config.color}`}>
      {config.icon}
      {config.label}
    </span>
  );
};

export default EscrowStatusBadge;